import React from 'react'
import { EvidenceUploadConfig, CommentUploadConfig } from '../../models/Account'
import { ConsentFormBody } from './ConsentFormBody'

type ConsentConfirmationPanelProps = {
  evidenceUploadConfig: EvidenceUploadConfig
  commentUploadConfig: CommentUploadConfig
  onSave: (params: { reason?: string; attachmentFileId?: string }) => void
  onCancel: () => void
  isLoading?: boolean
}

export const ConsentConfirmationPanel: React.FC<ConsentConfirmationPanelProps> = ({
  evidenceUploadConfig,
  commentUploadConfig,
  onSave,
  onCancel,
  isLoading = false,
}) => (
  <div className='p-2 d-flex flex-column gap-4'>
    <ConsentFormBody
      evidenceUploadConfig={evidenceUploadConfig}
      commentUploadConfig={commentUploadConfig}
      onSave={onSave}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  </div>
)
